import { api } from '../core';

export type DocumentProviderAddResponse = object;

type DocumentProviderAddProps = {
  documentId: string;
  providerId: string;
  invalidateData?: boolean;
};

const documentProviderAddApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postDocumentProviderAdd: builder.query<DocumentProviderAddResponse, DocumentProviderAddProps>({
      query: ({ documentId, providerId }: DocumentProviderAddProps) => ({
        url: `document/provider/add`,
        method: 'POST',
        body: {
          document_id: documentId,
          provider_id: providerId
        }
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          console.error('Error in postDocumentProviderAdd in onQueryStarted:', error);
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostDocumentProviderAddQuery } = documentProviderAddApi;
